import { FC } from 'react'
import { DevicesTabs } from '../../../useLibraryDetailsData'
import TabPanel from '../../../components/LibraryDetailsTabPanel'
import TrendsTab from '../../trends-tab'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'

export const TrendsTabPanel: FC = () => {
  const { tabValue } = useLibraryDetails()

  return (
    <TabPanel value={tabValue === DevicesTabs.Trends ? 0 : 10} index={0}>
      <TrendsTab />
    </TabPanel>
  )
}
